// Version : 0.0.2
// Author : SHIYAM
// LastEdit : SHIYAM
// Last ADD : Added version
// MODFIED DATE : 05-09-2025

// /* eslint-disable eslint-comments/disable-enable-pair */

import { takeLatest, put, all, call } from 'redux-saga/effects';

import RelatedPartiesActionTypes from './related-parties.types';
import {
	partiesDetailsAdd,
	fetchPartiesDetails,
	updatePartiesDetails,
	deletePartiesDetails,
} from './related-parties.service';
import {
	addBusinessPartiesSuccess,
	addBusinessPartiesFailure,
	addBusinessPartiesResponseChanged,
	updateBusinessPartiesSuccess,
	updateBusinessPartiesFailure,
	updateBusinessPartiesResponseChanged,
	fetchBusinessPartiesSuccess,
	fetchBusinessPartiesFailure,
	fetchBusinessPartiesResponseChanged,
	deleteBusinessPartiesResponseChanged,
	deleteBusinessPartiesFailure,
	deleteBusinessPartiesSuccess,
} from './related-parties.action';
import { encryptData } from '../../../_common/enode-decode';

import AlertManager from '../../../../utils/alertManager';
/** *********************  START ADD BUSINESS RELATED PARTIES  ******************** */
export function* businessPartiesAdd({ payload }: any) {
	try {
		const { businessID, companyID, userID, databaseName, relatedParties } = payload;
		const key = 'BusinessReletedPartiesKey';
		const jsonData = {
			BusinessID: businessID,
			CompanyID: companyID,
			CreatedBy: userID,
			DatabaseName: databaseName,
			ReletedPartiesListArr: relatedParties,
		};
		const encodeData = encryptData(jsonData, key);
		//@ts-ignore
		const responseData = yield call(partiesDetailsAdd, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(addBusinessPartiesFailure(responseData.data));
		} else {
			yield put(addBusinessPartiesSuccess(responseData.data));
		}
	} catch (error) {
		yield put(addBusinessPartiesFailure(error));
	}
}

export function* resetAddBusinessPartiesResponse() {
	yield put(addBusinessPartiesResponseChanged());
}

export function* onAddBusinessPartiesDetails() {
	yield takeLatest(RelatedPartiesActionTypes.ADD_RELATED_PARTIES_START, businessPartiesAdd);
}

export function* onAddBusinessPartiesResponseReset() {
	yield takeLatest(
		RelatedPartiesActionTypes.ADD_RELATED_PARTIES_RESPONSE_RESET,
		resetAddBusinessPartiesResponse,
	);
}
/** *********************  END ADD BUSINESS RELATED PARTIES ******************** */

/** *********************  START UPDATE BUSINESS RELATED PARTIES  ******************** */
export function* businessPartiesUpdate({ payload }: any) {
	try {
		const { businessID, companyID, userID, databaseName, relatedParties } = payload;
		const key = 'UpdateBusinessReletedPartiesKey';
		const jsonData = {
			BusinessID: businessID,
			CompanyID: companyID,
			CreatedBy: userID,
			DatabaseName: databaseName,
			ReletedPartiesListArr: relatedParties,
		};
		const encodeData = encryptData(jsonData, key);
		//@ts-ignore
		const responseData = yield call(updatePartiesDetails, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(updateBusinessPartiesFailure(responseData.data));
		} else {
			yield put(updateBusinessPartiesSuccess(responseData.data));
		}
	} catch (error) {
		yield put(updateBusinessPartiesFailure(error));
	}
}

export function* resetUpdateBusinessPartiesResponse() {
	yield put(updateBusinessPartiesResponseChanged());
}

export function* onUpdateBusinessPartiesDetails() {
	yield takeLatest(RelatedPartiesActionTypes.UPDATE_RELATED_PARTIES_START, businessPartiesUpdate);
}

export function* onUpdateBusinessPartiesResponseReset() {
	yield takeLatest(
		RelatedPartiesActionTypes.UPDATE_RELATED_PARTIES_RESPONSE_RESET,
		resetUpdateBusinessPartiesResponse,
	);
}
/** *********************  END UPDATE BUSINESS RELATED PARTIES ******************** */

/** *********************  START FETCH BUSINESS RELATED PARTIES  ******************** */
export function* businessPartiesFetch({ payload }: any) {
	try {
		const { businessID, companyID, userID, databaseName } = payload;
		const key = 'GetBusinessReletedPartiesKey';
		const jsonData = {
			BusinessID: businessID,
			CompanyID: companyID,
			UserID: userID,
			DatabaseName: databaseName,
		};
		const encodeData = encryptData(jsonData, key);
		//@ts-ignore
		const responseData = yield call(fetchPartiesDetails, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchBusinessPartiesFailure(responseData.data));
		} else {
			yield put(fetchBusinessPartiesSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchBusinessPartiesFailure(error));
	}
}

export function* resetFetchBusinessPartiesResponse() {
	yield put(fetchBusinessPartiesResponseChanged());
}

export function* onFetchBusinessPartiesDetails() {
	yield takeLatest(RelatedPartiesActionTypes.FETCH_RELATED_PARTIES_START, businessPartiesFetch);
}

export function* onFetchBusinessPartiesResponseReset() {
	yield takeLatest(
		RelatedPartiesActionTypes.FETCH_RELATED_PARTIES_RESPONSE_RESET,
		resetFetchBusinessPartiesResponse,
	);
}
/** *********************  END FETCH BUSINESS RELATED PARTIES ******************** */

export function* businessPartiesDelete({ payload }: any) {
	try {
		const { businessPartiesID, companyID, databaseName } = payload;
		const key = 'DeleteBusinessReletedPartiesKey';
		const jsonData = {
			BusinessPartiesID: businessPartiesID,
			CompanyID: companyID,
			DatabaseName: databaseName,
		};
		const encodeData = encryptData(jsonData, key);
		//@ts-ignore
		const responseData = yield call(deletePartiesDetails, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(deleteBusinessPartiesFailure(responseData.data));
		} else {
			yield put(deleteBusinessPartiesSuccess(responseData.data));
		}
	} catch (error) {
		yield put(deleteBusinessPartiesFailure(error));
	}
}

export function* resetDeleteBusinessPartiesResponse() {
	yield put(deleteBusinessPartiesResponseChanged());
}

export function* onDeleteBusinessPartiesDetails() {
	yield takeLatest(RelatedPartiesActionTypes.DELETE_RELATED_PARTIES_START, businessPartiesDelete);
}

export function* onDeleteBusinessPartiesResponseReset() {
	yield takeLatest(
		RelatedPartiesActionTypes.DELETE_RELATED_PARTIES_RESPONSE_RESET,
		resetDeleteBusinessPartiesResponse,
	);
}

export function* partiesDetailsSaga() {
	yield all([
		call(onAddBusinessPartiesDetails),
		call(onAddBusinessPartiesResponseReset),
		call(onUpdateBusinessPartiesDetails),
		call(onUpdateBusinessPartiesResponseReset),
		call(onFetchBusinessPartiesDetails),
		call(onFetchBusinessPartiesResponseReset),
		call(onDeleteBusinessPartiesDetails),
		call(onDeleteBusinessPartiesResponseReset),
	]);
}
